import { useParams, useSearchParams } from "react-router";
import { useGetCustomForm } from "../hooks/useGetCustomForm";
import FormAuthentication from "./FormAuthentication";
import FormEdit from "./FormEdit";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import CustomFormError from "./CustomFormError";

export default function CustomForm() {
    const { publicId, formDataNumber } = useParams<{
        publicId: string;
        formDataNumber: string;
    }>();

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const { data, isLoading, error } = useGetCustomForm({
        publicId: publicId,
        formDataNumber: Number.parseInt(formDataNumber),
        token: token || undefined,
    });

    const clientAuthenticationRequired =
        data?.customForm.authenticationRequired && !data?.customForm.authenticationSuccessful;

    return isLoading ? (
        <LoadingOverlay />
    ) : (
        <>
            {error ? (
                <CustomFormError />
            ) : clientAuthenticationRequired ? (
                <FormAuthentication
                    authenticationErrorMessage={data.customForm.authenticationFormError || ""}
                    publicId={publicId}
                    formDataNumber={formDataNumber}
                    authenticationMethod={data.customForm.authenticationMethod}
                    cultureDateFormat={data.customForm.cultureDateFormat}
                />
            ) : (
                <FormEdit
                    formData={data.customForm}
                    sgName={data.customForm.sgName || ""}
                    formName={data.customForm.name || "Custom Form"}
                    customFormModel={data}
                    publicId={publicId}
                />
            )}
        </>
    );
}
